import TermsConditionsDialog from "@/components/TermsConditionsDialog";

/**
 * Inline conditions block shown on the Complete Booking page.
 * Only Standard Court Rental is offered; Special (Palm Haven / Bamboo Grove)
 * was retired — this component always renders the standard bullet list.
 */
const BookingConditions = ({ agreed = false, onAgreedChange }) => {
  const heading = "Standard Court Rental · Conditions";

  const bulletCls = "flex gap-2";
  const bullet = <span className="text-[#8cc63f] font-bold flex-shrink-0">•</span>;

  const renderStandard = () => (
    <>
      <ul className="space-y-2 text-sm text-[#e4e4e7] leading-relaxed">
        <li className={bulletCls}>
          {bullet}
          <span>
            Good for <span className="text-white font-semibold">8 players</span> with a{" "}
            <span className="text-white font-semibold">maximum of 15 players</span>.
          </span>
        </li>
        <li className={bulletCls}>
          {bullet}
          <span>
            Each player in excess of 8 must pay{" "}
            <span className="text-white font-semibold">₱100</span>.
          </span>
        </li>
        <li className={bulletCls}>
          {bullet}
          <span>
            <span className="text-white font-semibold">
              No entrance fee for guests and visitors.
            </span>
          </span>
        </li>
        <li className={bulletCls}>
          {bullet}
          <span>
            <span className="text-white font-semibold">Bring your own ball.</span>
          </span>
        </li>
        <li className={bulletCls}>
          {bullet}
          <span>
            <span className="text-white font-semibold">Party trays and group meals</span>{" "}
            have a{" "}
            <span className="text-white font-semibold">
              corkage fee of ₱100 per head
            </span>{" "}
            <span className="text-[#a1a1aa]">
              (players and guests 7 years old and above)
            </span>.
          </span>
        </li>
        <li className={bulletCls}>
          {bullet}
          <span>
            <span className="text-white font-semibold uppercase">
              Outside alcoholic beverages is prohibited
            </span>. Liquors and cocktails are available at{" "}
            <span className="text-white font-semibold">Assenda cafe</span>.
          </span>
        </li>
      </ul>
      <div className="mt-4 rounded-sm border border-amber-500/30 bg-amber-500/5 px-3 py-2.5">
        <p className="text-xs text-[#e4e4e7] leading-relaxed">
          <span className="inline-flex items-center gap-1 mr-1 text-[10px] font-bold uppercase tracking-wider text-amber-400">
            ⚠ Note
          </span>{" "}
          Guests with a confirmed succeeding booking may arrive during your
          reserved time without being counted, but if they stay in the court
          area for more than{" "}
          <span className="font-semibold text-white">30 minutes</span> before
          their booking, the applicable extra pax and corkage fees will apply.
        </p>
      </div>
    </>
  );

  return (
    <div
      className="card-surface p-6 mb-6"
      data-testid="booking-conditions-standard"
    >
      <p className="label-text mb-1">Conditions</p>
      <p className="text-xs font-bold uppercase tracking-wider text-[#8cc63f] mb-3">
        {heading}
      </p>
      {renderStandard()}
      <div className="mt-5 pt-4 border-t border-white/10">
        <label
          htmlFor="terms-agree-checkbox"
          className="flex items-start gap-3 cursor-pointer group"
        >
          <input
            id="terms-agree-checkbox"
            type="checkbox"
            checked={agreed}
            onChange={(e) => onAgreedChange?.(e.target.checked)}
            data-testid="terms-agree-checkbox"
            required
            className="mt-0.5 h-4 w-4 flex-shrink-0 accent-[#8cc63f] cursor-pointer"
          />
          <span className="text-xs sm:text-sm text-[#e4e4e7] leading-relaxed">
            I hereby confirm that I have read, understood, and agree to the
            Rental Conditions,{" "}
            <TermsConditionsDialog
              triggerLabel="Cancellation Policy, Court Rules, and Waiver of Liability"
              triggerClassName="text-[#8cc63f] underline underline-offset-2 hover:text-white transition-colors cursor-pointer font-semibold"
            />
            .
          </span>
        </label>
        <button
          type="button"
          data-testid="proceed-to-payment-button"
          disabled={!agreed}
          onClick={() => {
            document.getElementById("your-information")?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }}
          className="mt-4 w-full sm:w-auto sm:ml-auto sm:flex whitespace-nowrap text-xs px-5 py-2.5 bg-[#8cc63f] text-black font-semibold uppercase tracking-wider rounded-sm hover:bg-[#9ed15c] transition-colors disabled:opacity-40 disabled:cursor-not-allowed inline-flex items-center justify-center gap-1.5"
        >
          Proceed to Payment
          <span aria-hidden>→</span>
        </button>
      </div>
    </div>
  );
};

export default BookingConditions;
